module.exports = __webpack_public_path__ + "img/hiring.4599cbfd.svg";